import { optionalChaining } from "@/utils/optionalChaining"
import Vue from "vue"

const MyPlugin = {
  install(vue) {
    vue.prototype.$$ = optionalChaining
  },
}
Vue.use(MyPlugin)
